import { Extension } from '../../../../node_modules/tiptap/dist/tiptap.esm.js';
import { history, undo, redo } from '../../../../node_modules/prosemirror-history/dist/index.es.js';

/* eslint-disable */
class History extends Extension {
  get name() {
    return 'history';
  }

  get defaultOptions() {
    return {
      depth: '',
      newGroupDelay: ''
    };
  }

  keys() {
    const keymap = {
      'Mod-z': undo,
      'Mod-y': redo,
      'Shift-Mod-z': redo
    };
    return keymap;
  }

  get plugins() {
    return [history({
      depth: this.options.depth,
      newGroupDelay: this.options.newGroupDelay
    })];
  }

  commands() {
    return {
      undo: () => undo,
      redo: () => redo
    };
  }

}

export default History;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/extensions/History.js